import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getCmsFaqs = createAsyncThunk(
  "getCmsFaqs/getCmsUsersFaqs",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("cms/faqs", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const getCmsFaqsSlice = createSlice({
  name: "getCmsFaqs",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCmsFaqs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCmsFaqs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCmsFaqs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getCmsFaqsSlice.reducer;
